import { useEffect, useRef } from 'react';

const CONFETTI = [
  { left: '8%', delay: '0s', duration: '2.4s', color: '#00C0B9', size: 8, round: false },
  { left: '18%', delay: '0.15s', duration: '2.8s', color: '#F59E0B', size: 10, round: true },
  { left: '28%', delay: '0.35s', duration: '2.2s', color: '#EC4899', size: 7, round: false },
  { left: '40%', delay: '0.05s', duration: '2.6s', color: '#3B82F6', size: 9, round: true },
  { left: '52%', delay: '0.4s', duration: '2.9s', color: '#10B981', size: 8, round: false },
  { left: '62%', delay: '0.2s', duration: '2.3s', color: '#8B5CF6', size: 11, round: true },
  { left: '74%', delay: '0.5s', duration: '2.7s', color: '#F43F5E', size: 7, round: false },
  { left: '84%', delay: '0.1s', duration: '2.5s', color: '#00C0B9', size: 9, round: true },
  { left: '92%', delay: '0.3s', duration: '2.1s', color: '#F59E0B', size: 8, round: false },
  { left: '12%', delay: '0.55s', duration: '2.6s', color: '#6366F1', size: 6, round: true },
  { left: '48%', delay: '0.25s', duration: '2.4s', color: '#14B8A6', size: 10, round: false },
  { left: '68%', delay: '0.45s', duration: '2.8s', color: '#FB7185', size: 7, round: true },
];

function SubmitSuccessCelebration({
  description = 'پاسخ‌هات با موفقیت ثبت شد. منتظر بازخورد معلم باش.',
  onClose,
  open = false,
  title = 'آفرین!',
}) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const timer = window.setTimeout(() => {
      onCloseRef.current?.();
    }, 4200);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.clearTimeout(timer);
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="submit-success-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="submit-success-title"
      onClick={() => onCloseRef.current?.()}
    >
      <div
        className="submit-success-card"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="submit-success-confetti" aria-hidden="true">
          {CONFETTI.map((piece, index) => (
            <span
              key={index}
              className="submit-success-confetti-piece"
              style={{
                left: piece.left,
                width: piece.size,
                height: piece.size,
                borderRadius: piece.round ? '9999px' : '2px',
                background: piece.color,
                animationDelay: piece.delay,
                animationDuration: piece.duration,
              }}
            />
          ))}
        </div>

        <div className="submit-success-glow" aria-hidden="true" />

        <div className="submit-success-icon-wrap" aria-hidden="true">
          <span className="submit-success-ring" />
          <span className="submit-success-ring submit-success-ring-delay" />
          <span className="submit-success-hand">👏</span>
        </div>

        <h2 id="submit-success-title" className="submit-success-title">
          {title}
        </h2>
        <p className="submit-success-description">{description}</p>

        <button
          type="button"
          className="submit-success-button"
          onClick={() => onCloseRef.current?.()}
        >
          عالی بود!
        </button>
      </div>
    </div>
  );
}

export default SubmitSuccessCelebration;
